import { Controller, useFormContext, useWatch } from "react-hook-form";
import { Checkbox, FormControlLabel, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import { useIntegrationTypeReducer } from "@/main/store/integrationType";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import * as S from "./styles";

function InterfaceDropdown() {
	const { control, clearErrors, resetField, setValue } = useFormContext();
	const watcherInterface = useWatch({
		control,
		name: "interface",
	});
	const watcherNullInterface = useWatch({
		control,
		name: "nullInterface",
	});
	const { integrationInterface: integrationInterfaceReducer } = useIntegrationTypeReducer();
	const disabledIntegrationInterface =
		watcherNullInterface ||
		isNullUndefined(integrationInterfaceReducer.data) ||
		integrationInterfaceReducer?.data?.length === 1;

	return (
		<S.Container>
			<KogAutoCompleteControlled
				id="id-mappingCodes-select-interface"
				nameCustom="interface"
				disableClearable
				label={getTranslateByKey("information.interface")}
				isDefaultValueUnique
				control={control}
				setValueCustom={setValue}
				options={integrationInterfaceReducer.data}
				isLoading={integrationInterfaceReducer.isLoading}
				disabled={disabledIntegrationInterface}
				onChangeCustom={() => {}}
			/>
			<Controller
				name="nullInterface"
				control={control}
				render={({ field: { onChange, value } }) => (
					<S.AreaCheckbox>
						{!isNullUndefined(watcherInterface) && (
							<IconButton
								className="ClearableIcon"
								onClick={() => {
									if (!isNullUndefined(watcherInterface)) {
										clearErrors("interface");
										resetField("interface");
									}
								}}
							>
								<ClearIcon fontSize="small" />
							</IconButton>
						)}
						<FormControlLabel
							label={getTranslateByKey("information.noInterface")}
							control={
								<Checkbox
									color="primary"
									checked={value}
									onChange={(e) => {
										onChange(e.target.checked);
										if (e.target.checked) {
											clearErrors("interface");
											resetField("interface");
										}
									}}
									id="id-register-checkBox-nullInterface"
								/>
							}
						/>
					</S.AreaCheckbox>
				)}
			/>
		</S.Container>
	);
}

export default InterfaceDropdown;
